export default __webpack_public_path__ + "static/media/arrowchecked.7ffb67c1.svg";